import { message } from 'antd';

/**
 * Hotel search endpoints answer provider failures with HTTP 200 and
 * `{ status: 'error', data: { message, info, code } }` (e.g. Ratehawk's
 * "checkout cannot be later than 30 days since checkin"). The search hooks
 * unwrap `response.data.data`, which used to silently turn those errors into
 * an empty result state.
 *
 * `unwrapHotelSearchBody` keeps the unwrap behavior for successes but, on an
 * error body, surfaces the backend message as a toast and returns an empty
 * `hotels` payload (plus `searchError`) so consumers keep working.
 */

// One shared key so parallel hotel queries (byIds + all) don't stack toasts.
const HOTEL_SEARCH_ERROR_TOAST_KEY = 'hotel-search-error';

export const showHotelSearchError = (msg?: string) => {
  if (!msg) return;
  message.error({
    content: msg,
    key: HOTEL_SEARCH_ERROR_TOAST_KEY,
    duration: 5,
  });
};

export const unwrapHotelSearchBody = (body: any) => {
  if (body?.status === 'error') {
    showHotelSearchError(body?.data?.message);
    return {
      hotels: [],
      optional_filters: undefined,
      searchError: body?.data ?? null,
    };
  }
  return body?.data;
};
